import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import ExcludeFromReports from 'assets/icons/settings-menu/ExcludeFromReports.inline.svg';
import ExcludeFromSpendingPlan from 'assets/icons/settings-menu/ExcludeFromSpendingPlan.inline.svg';
import classNames from 'classnames';
import QCheckbox from 'components/QCheckbox';
import * as React from 'react';
import { memo, useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 262,
  },

  noOffset: {
    marginLeft: 0,
    height: 28,
  },

  excludeText: {
    color: theme.palette.text.secondary,
    paddingBottom: 12,
  },
  imgClass: {
    marginLeft: 8,
    height: 24,
    width: 24,
  },
  unChecked: {
    display: 'flex',
    alignItems: 'center',
    userSelect: 'none',
  },
  checkedColor: {
    color: theme.palette.primary.main,
  },
  subText: {
    paddingLeft: 38,
    color: theme.palette.text.secondary,
    userSelect: 'none',
  },
  displayGrid: {
    display: 'grid',
    marginBottom: 8,
  },
}));

function VisibilitySection({
  excludeReports,
  excludeF2S,
  setExcludeReports,
  setExcludeF2S,
  className,
  leftAlign = false,
  disabledReports,
  indeterminateF2S,
  indeterminateReports,
}: {
  excludeReports?: boolean | null;
  excludeF2S?: boolean | null;
  setExcludeReports: (exclude: boolean) => void;
  setExcludeF2S: (exclude: boolean) => void;
  className?: string;
  leftAlign?: boolean;
  disabledReports?: boolean;
  indeterminateF2S?: boolean;
  indeterminateReports?: boolean;
}) {
  const { classes, cx } = useStyles();

  const onReportsClick = () => {
    setExcludeReports(!excludeReports);
  };
  const onF2SClick = () => {
    setExcludeF2S(!excludeF2S);
  };

  const vars = [
    {
      name: 'Spending Plan',
      image: <ExcludeFromSpendingPlan className={classes.imgClass} />,
      checked: excludeF2S,
      onChange: onF2SClick,
      id: 'ignore-spending-plan-toggle',
      subText: 'Affects Spending Plan calculations.',
      disabled: false,
      indeterminate: indeterminateF2S,
    },
    {
      name: 'Reports',
      image: <ExcludeFromReports className={classes.imgClass} />,
      checked: disabledReports || excludeReports,
      onChange: onReportsClick,
      id: 'ignore-reports-toggle',
      subText: 'Affects Reports, Watchlists, and Upcoming Summary.',
      disabled: disabledReports,
      indeterminate: indeterminateReports,
    },
  ];

  const noOffset = useMemo(() => ({ root: classes.noOffset }), [classes.noOffset]);

  return (
    <div className={cx(classes.column, className)}>
      <Typography variant='paragraphRegular' className={classes.excludeText}>
        Exclude from:
      </Typography>
      {vars.map((item) => (
        <div className={classes.displayGrid} key={item.id}>
          <FormControlLabel
            disabled={item.disabled}
            control={<QCheckbox sx={{ pl: 0 }} indeterminate={item.indeterminate && item.checked === null} />}
            label={
              <div className={classNames(classes.unChecked, item.checked && classes.checkedColor)}>
                <Typography>{item.name}</Typography>
                {item.image}
              </div>
            }
            labelPlacement='end'
            onChange={item.onChange}
            checked={item.checked ?? false}
            classes={leftAlign ? undefined : noOffset}
            id={item.id}
          />
          <Typography variant='captionRegular' className={classes.subText}>
            {item.subText}
          </Typography>
        </div>
      ))}
    </div>
  );
}

export default memo(VisibilitySection);
